import React from 'react';
import './InputGroup.scss';
import classNames from 'classnames';

const InputGroup = ({children,className, ...props}) => {
  return (
    <div className={classNames('ui-input-group', className)}>
      {children}
    </div>
  );
};

export default InputGroup;
